import React from "react";
import { ArrowLeftOutlined, CheckOutlined } from "@ant-design/icons";

const OnboardingStepper = ({ current, total, onBack }) => {
  return (
    <div className="ob-stepper">
      <nav aria-label="Setup progress">
        <ol>
          {Array.from({ length: total }, (_, index) => {
            const isDone = index < current;
            const isCurrent = index === current;
            return (
              <li
                key={index}
                className={isDone ? "is-done" : isCurrent ? "is-current" : ""}
                aria-current={isCurrent ? "step" : undefined}
                aria-label={`Step ${index + 1} of ${total}${
                  isDone ? ", completed" : ""
                }`}
              >
                <span className="ob-step-dot">
                  {isDone ? <CheckOutlined /> : index + 1}
                </span>
              </li>
            );
          })}
        </ol>
      </nav>
      {onBack && (
        <button type="button" className="ob-back" onClick={onBack}>
          <ArrowLeftOutlined /> Back
        </button>
      )}
    </div>
  );
};

export default OnboardingStepper;
